import { EditorView } from 'codemirror'
import { MatchDecorator, ViewPlugin, Decoration, WidgetType } from '@codemirror/view'
class FieldNameWigdet extends WidgetType {
  text
  constructor(text) {
    super()
    this.text = text
  }

  toDOM() {
    let wrap = document.createElement('span')
    wrap.setAttribute('title', this.text)
    wrap.className = 'cm-field-name'
    wrap.innerText = this.text
    return wrap
  }
}

export const getFieldNameWidget = (regexp) => {
  const fieldNameMatcher = new MatchDecorator({
    regexp,
    decoration: (match) => {
      return Decoration.replace({
        widget: new FieldNameWigdet(match[1])
      })
    }
  })

  return ViewPlugin.fromClass(
    class {
      fieldNames
      constructor(view) {
        this.fieldNames = fieldNameMatcher.createDeco(view)
      }
      update(update) {
        this.fieldNames = fieldNameMatcher.updateDeco(update, this.fieldNames)
      }
    },
    {
      decorations: (instance) => instance.fieldNames,
      provide: (plugin) =>
        EditorView.atomicRanges.of((view) => {
          return view.plugin(plugin)?.fieldNames || Decoration.none
        })
    }
  )
}
